import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import PlanAccionServices from "./planAccion_services";

export const getPlanAcciones = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PLAN_ACCION,
      payload: true,
    });
    const resp = await PlanAccionServices.getPlanAcciones(filters);
    dispatch({
      type: actions.GET_PLAN_ACCION,
      payload: resp.data, // agregar .data
    });
    dispatch({
      type: actions.PLAN_ACCION_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLAN_ACCION_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PLAN_ACCION,
      payload: false,
    });
  }
}

export const deletePlanAccion = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_PLAN_ACCION,
      payload: true,
    });
    await PlanAccionServices.deletePlanAccion(id);
    const { data, count } = getState().planAccion.planAccion;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_PLAN_ACCION,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.PLAN_ACCION_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLAN_ACCION_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PLAN_ACCION,
      payload: false,
    });
  }
}

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const editPlanAccion = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_PLAN_ACCION,
      payload: true,
    });
    const resp = await PlanAccionServices.editPlanAccion(req.id, req);
    const { data, count } = getState().planAccion.planAccion;
    let _data = data.slice();
    _data[index] = resp.data;
    dispatch({
      type: actions.GET_PLAN_ACCION,
      payload: {
        data: _data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_PLAN_ACCION_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLAN_ACCION_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PLAN_ACCION,
      payload: false,
    });
  }
}

export const savePlanAccion = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_PLAN_ACCION,
      payload: true,
    });
    const resp = await PlanAccionServices.savePlanAccion(req);
    const { data, count } = getState().planAccion.planAccion;
    dispatch({
      type: actions.GET_PLAN_ACCION,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_PLAN_ACCION_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_PLAN_ACCION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_PLAN_ACCION,
      payload: false,
    });
  }
};
